import { deprecatedPropValueMessage } from "../../utils/deprecationUtils";
export var disabledTypeEnum = {
    STYLE_ONLY: 'style-only'
};
var deprecatedAppearanceValuesToUpdatedMap = {
    primary: 'filled',
    secondary: 'lined',
    tertiary: 'ghost'
};
var isDeprecatedAppearance = function(appearance) {
    if (typeof appearance === 'undefined') {
        return false;
    }
    return Object.keys(deprecatedAppearanceValuesToUpdatedMap).includes(appearance);
};
export var mapDeprecatedAppearanceToUpdated = function(initialAppearance) {
    if (isDeprecatedAppearance(initialAppearance)) {
        deprecatedPropValueMessage({
            componentName: 'Button',
            date: 'Q3',
            propName: 'appearance',
            propValue: initialAppearance,
            upgradeURL: 'https://carina.core.cvent.org/blog/2021/02/23/deprecation-button-appearance-values'
        });
        return deprecatedAppearanceValuesToUpdatedMap[initialAppearance];
    }
    return initialAppearance;
};
